import { monthsShortForm } from '../../../../Constants/HomePage';

export const calculateDueDate = (enteredDate) => {
  let date = new Date(enteredDate);
  let time = new Date(date.getTime());
  time.setDate(time.getDate() - 92);
  time.setFullYear(time.getFullYear() + 1);
  time.setDate(time.getDate() + 7);
  return time;
};
export const getFormattedDate = (dueDate) => {
  const text = getText('' + dueDate.getDate());
  let requiredDate =
    dueDate.getDate() +
    text +
    ' ' +
    monthsShortForm[dueDate.getMonth()] +
    ', ' +
    dueDate.getFullYear();
  return requiredDate;
};
const getText = (date) => {
  let text = 'th';
  if (date == '1') {
    text = 'st';
  } else if (date == '2') {
    text = 'n';
  } else if (date == '3') {
    date = 'rd';
  }
  return text;
};
